import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { formSettings } from './../settings';
import { FormattedMessage } from 'react-intl';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import Signature from '../../../../../../components/signature';
import messages from '../../../../../../text/messages';
import { getOfferLetter, setProgressionProperties } from '../../../../../../reducers/onboarding';
import { maskSSN } from '../../../../../../utilities/string';
import { getAddresses } from '../../../../../../reducers/addresses';
import { getSignatures, createICAgreement } from '../../../../../../reducers/documents';
import { sign } from '../../../../../../reducers/signatures';
import { updateUserProfile } from '../../../../../../reducers/identity';
import { Signatures } from '../../../../../../utilities/signatureTypes';
import mixpanel from 'mixpanel-browser';

const INV_DISC_FORM = 'INV_DISC_FORM';

class ContractorOfferLetterStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'ic', step: 'ContractorOfferLetterStep' } });

        const { role, profile, job, progression, offerLetter, getAddresses, getSignatures, setProgressionProperties, getOfferLetter } = this.props;

        if (!offerLetter) {
            getOfferLetter(job.id, role.id, role.type, 'offer-letter');
        }

        getSignatures(role, signaturesResult =>
            setProgressionProperties({
                offerLetterSignature: signaturesResult.find(s => s.name === `${Signatures.types.IC_AGREEMENT.name}:${job.id}`) !== undefined
            })
        );

        if (!progression || !progression.personalInformation || !progression.mailingAddress) {
            getAddresses(role, addresses => {
                setProgressionProperties({
                    personalInformation: {
                        firstName: profile.first_name,
                        middleName: profile.middle_name,
                        lastName: profile.last_name,
                        email: profile.email,
                        phoneNumber: profile.phone,
                        dateOfBirth: profile.birthday_date,
                        socialSecurityNumber: maskSSN(profile.ssn_bg_check)
                    }
                });

                if (addresses && addresses.length > 0) {
                    setProgressionProperties({ mailingAddress: addresses[0] });
                }
            });
        }
    }

    submit(values, action) {
        const { role, job, sign, setProgressionProperties, profile, updateUserProfile, createICAgreement } = this.props;
        updateUserProfile({ ...profile, inventions_disclosed: values.inventions_disclosed }, () => {
            sign(role, `${Signatures.types.IC_AGREEMENT.name}:${job.id}`, signature => {
                setProgressionProperties({ offerLetterSignature: true });
                createICAgreement(job.id, job.contractor_id, signature.id);
                action();
            });
        });
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, job, progression, offerLetter } = this.props;
        if (!progression || !progression.personalInformation || !progression.mailingAddress || progression.offerLetterSignature === undefined || !offerLetter) {
            return null;
        }

        return (
            <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                <div className="row">
                    <div className="col-xs-12">
                        <FormattedMessage
                            id={'offerLetter.intro1'}
                            defaultMessage={
                                'There are two documents that detail how you will be engaged.  \
                                 The first, this Independent Service Provider Agreement, includes general terms and conditions. \
                                 The second, on the next page, specifies the details of your work for the client.'
                            }
                        />
                    </div>
                </div>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedMessage
                            id={'offerLetter.intro2'}
                            defaultMessage={
                                'Please review and e-sign both documents. \
                                 You can download copies from your dashboard if you ever need to.'
                            }
                        />
                    </div>
                </div>
                <div className="row section">
                    <div className="col-xs-12">
                        <div className="scrolled" dangerouslySetInnerHTML={{ __html: offerLetter }} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <Signature name={`${Signatures.types.OFFER_LETTER.name}:${job.id}`} />
                    </div>
                </div>
                <WizardButtons disabled={submitting} back={{ action: back }} submit={{ message: <FormattedMessage {...messages.signAndContinue} /> }} />
            </form>
        );
    }
}

ContractorOfferLetterStep = reduxForm(formSettings)(ContractorOfferLetterStep);
const selector = formValueSelector(formSettings.form);
const mapStateToProps = state => {
    const progression = state.onboarding.progression;
    const profile = state.identity.profile;

    return {
        role: state.identity.role,
        details: state.identity.details,
        profile,
        job: state.onboarding.job,
        client: state.onboarding.client,
        admin: state.users.adminDetails,
        position: state.onboarding.position,
        offerLetter: state.onboarding.offerLetter,
        isInventionsDisclosed: selector(state, 'inventions_disclosed') === true,
        workerAddress: (state.addresses.list || [{}])[0],
        progression,
        inventionsDisclosureDocument: state.documents[INV_DISC_FORM] || { list: [] },
        initialValues: {
            acknowledgeOfferLetterSignature: progression.offerLetterSignature,
            inventions_disclosed: profile.inventions_disclosed
        }
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAddresses,
            getSignatures,
            createICAgreement,
            getOfferLetter,
            sign,
            setProgressionProperties,
            updateUserProfile
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ContractorOfferLetterStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/contractor/contractorOfferLetter.jsx